import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHookSection } from '../components/OpeningHookSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedApproachesSection } from '../components/FailedApproachesSection';
import { MechanismSection } from '../components/MechanismSection';
import { DeliverablesSection } from '../components/DeliverablesSection';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
export function LandingPage() {
  return <main className="min-h-screen bg-cream" data-id="element-103">
      <HeroSection data-id="element-104" />
      <OpeningHookSection data-id="element-105" />
      <ProblemSection data-id="element-106" />
      <FailedApproachesSection data-id="element-107" />
      <MechanismSection data-id="element-108" />
      <DeliverablesSection data-id="element-109" />
      <AudienceSection data-id="element-110" />
      <HowItWorksSection data-id="element-111" />
      <ProofSection data-id="element-112" />
      <FAQSection data-id="element-113" />
      <OfferSection data-id="element-114" />
    </main>;
}